module.exports = __webpack_public_path__ + "static/media/Ninety.c9942fec.ogg";